/**
 * external libs
 */
import {Routes, Route} from "react-router";
import React, {Suspense, lazy, useMemo, useEffect} from "react";
/**
 * hooks
 */
import {useNavigationSetup} from "../../hooks/useNavigationSetup";
/**
 * routes
 */
import {webRoutes, RouteConfig} from "./routes/web.routes";
import Layout from "../Layout";
import {UserProvider} from "../../context/user.context";
import {AuthService} from "../../services";


export default function RoutesComponent() {
    const routes = useMemo(() => webRoutes(), [])

    // Register navigation for axios interceptors
    useNavigationSetup();

    return (
        <Suspense fallback={null}>
            <Routes>
                {/* Routes without layout */}
                {routes.withoutLayout.map((route: RouteConfig, i: number) => {
                    const Component = route.element
                    return (
                        <Route key={i}
                               path={route.path}
                               element={<Component/>}/>
                    )
                })}

                {/* Routes with layout - wrapped in a single layout route */}
                <Route path="/*" element={
                    <UserProvider>
                        <Layout>
                            <Routes>
                                {routes.withLayout.map((route: RouteConfig, i: number) => {
                                    const Component = route.element
                                    return (
                                        <Route key={i}
                                               path={route.path}
                                               element={<Component/>}/>
                                    )
                                })}
                            </Routes>
                        </Layout>
                    </UserProvider>
                }/>
            </Routes>
        </Suspense>
    )
}

